import React from "react";
import logo from "../assets/logo.png";

/**
 * AnswerMyQ logo — renders the actual brand PNG.
 */
const Logo = ({ height = 48 }) => (
  <img
    src={logo}
    alt="AnswerMyQ"
    style={{ height, objectFit: "contain" }}
  />
);

export default Logo;
